const title = 'item_price_breadcrumb'
const crumbs = [{ label: title }]
const url = '/settings/product-price'
const PRODUCT_PRICE_URI = 'product-price/*'

export { title, crumbs, url, PRODUCT_PRICE_URI }
